import { Box, FormHelperText, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectMultiV2, InputSelectNative } from '../../../common/Form';
import DatePickerCmp from '../../../common/DatePicker';
import { GroupCheckbox, GroupRadio, GroupSwitch, SingleCheckbox, SingleRadio, SingleSwitch } from '../../../common/RadioAndCheckbox';
import { isEmpty } from 'lodash';
import Creatable from '../../../common/Creatable';
import { Fragment } from 'react';
import PhotoUpload from '../../../common/PhotoUpload';

const HEADER = {
    "equipement" : "Immobilisation",
    "materiel" : "Matériel",
    "vehicule" : "Véhicule",
}

class Equipements extends Component {
    state = { 
        // equipement_intern_id: this.props.equipement ? this.props.equipement.equipement_intern_id : "",
        equipement_quantity: this.props.equipement ? this.props.equipement.equipement_quantity : 1,
        equipement_name: this.props.equipement ? this.props.equipement.equipement_name : "",
        equipement_type: this.props.equipement ? this.props.equipement.equipement_type : "",
        equipement_brut_amount: this.props.equipement ? this.props.equipement.equipement_brut_amount : "",
        equipement_brand: this.props.equipement ? this.props.equipement.equipement_brand : "",
        equipement_state: this.props.equipement ? this.props.equipement.equipement_state : "",
        equipement_state: this.props.equipement ? this.props.equipement.equipement_state : "",
        equipement_remarks: this.props.equipement ? this.props.equipement.equipement_remarks : "",
        equipement_date_acquisition: this.props.equipement ? new Date(this.props.equipement.equipement_date_acquisition) : new Date(),
        equipement_date_service: this.props.equipement ? new Date(this.props.equipement.equipement_date_service) : null,
        car_assurance_start: this.props.equipement ? new Date(this.props.equipement.car_assurance_start) : null,
        car_assurance_end: this.props.equipement ? new Date(this.props.equipement.car_assurance_end) : null,
        car_controle_tech_start: this.props.equipement ? new Date(this.props.equipement.car_controle_tech_start) : null,
        car_controle_tech_end: this.props.equipement ? new Date(this.props.equipement.car_controle_tech_end) : null,
        equipement_category: this.props.equipement ? this.props.equipement.equipement_category : "",
        equipement_categoryDisplay: this.props.equipement && this.props.equipement.equipement_category ? {
            value: this.props.equipement.equipement_category, 
            label: this.props.CATEGORIES.CHILD[this.props.equipement.equipement_category].category_name
        } : {value:"", label:""},
        equipement_localisation: this.props.equipement ? this.props.equipement.equipement_localisation : "",
        equipement_localisationDisplay: this.props.equipement && this.props.equipement.equipement_localisation ? {
            value: this.props.equipement.equipement_localisation, 
            label: `${this.props.LOCALISATIONS.PARENT[this.props.LOCALISATIONS.CHILD[this.props.equipement.equipement_localisation].loc_parent].loc_name} - ${this.props.LOCALISATIONS.CHILD[this.props.equipement.equipement_localisation].loc_name}`
        } : {value:"", label:""},
        equipement_amt_length: this.props.equipement ? this.props.equipement.equipement_amt_length : "",
        equipement_annual_rate: this.props.equipement ? this.props.equipement.equipement_annual_rate : "",
        equipement_sn: this.props.equipement ? this.props.equipement.equipement_sn : "",
        equipement_desc: this.props.equipement ? this.props.equipement.equipement_desc : "",
        car_matricule: this.props.equipement ? this.props.equipement.car_matricule : "",
        car_km_start: this.props.equipement ? this.props.equipement.car_km_start : "",
        car_carburant: this.props.equipement ? this.props.equipement.car_carburant : "",

        equipement_photo_front: null,
        equipement_photo_back: null,
        equipement_photo_top: null,
        equipement_photo_bottom: null,
        equipement_photo_left: null,
        equipement_photo_right: null,

        permanent_loan: this.props.equipement ? this.props.equipement.permanent_loan : "",
        short_loan: this.props.equipement ? this.props.equipement.short_loan : "",
        no_loan: this.props.equipement ? this.props.equipement.no_loan : "",

        equipement_tags: [],
        equipement_tagsID: [],

        errors:{},

        loan_type: "",
        rattrapage: false,
    }

    componentDidMount = () => {
        const { equipement, IMMO_TAGS } = this.props;
        if (this.props.update){
            let loan_type = ""
            if( equipement.permanent_loan){
                loan_type = "permanent_loan"
            } else if( equipement.short_loan){
                loan_type = "short_loan"
            } else if( equipement.no_loan){
                loan_type = "no_loan"
            } 

            let tagDisplay = []
            let tagID = []
            
            if(!isEmpty(equipement.equipement_tags)){
                tagID = equipement.equipement_tags.split(", ")
                tagID.map( tag => {
                    tagDisplay.push({
                        value: tag,
                        label: IMMO_TAGS[tag].immo_tag_name,
                        disabled: false,
                    })
                })
            }
           
            this.setState({
                equipement_tags: tagDisplay,
                equipement_tagsID: tagID,
                loan_type
            })
        }
    }
    handleChange = (e) => {
        const { name, value} = e.target;
        // TO DO add regex float
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "equipement_brut_amount"]

        if (name === "equipement_annual_rate") {
            let amtLgth = value ? 100 / value : 0.0
            this.setState({
                [name]: value,
                equipement_amt_length: parseFloat(amtLgth)
            })
        } else if (name === "equipement_amt_length"){
            let rate = value ? 100 / value : 0.0
            this.setState({
                [name]: value,
                equipement_annual_rate: parseFloat(rate)
            })
           
        } else  if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: parseFloat(value)
            })
        }
           
    }
    handleChangeCat = (name, option) => {
        if(option){
            this.setState({
                [name]: option.value || "",
                [`${name}Display`]: option
            })
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {}
            })

        }
    }
    
    handleChangeDate = (name, date) => {
        const { update, equipement, } = this.props;
        let newDate = date ? new Date(date.setHours(0,0, 0, 0)) : null
        let errors = Object.assign({}, this.state.errors)
        if (update && !equipement.equipement_is_new &&
            name === "equipement_date_acquisition" && 
            newDate && 
            ( newDate.getFullYear() !== new Date(equipement.equipement_date_acquisition).getFullYear() )
        ) {
            errors.equipement_date_acquisition = "Impossible de modifier l'année d'acquisition"
            this.setState({
                errors
            })
        } else {
            errors.equipement_date_acquisition = ""
            this.setState({
                [name]: newDate,
                errors
            })
        }
    }
    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }
    handleChangeMulti = (option, field) => {
        console.log('====================================');
        console.log({option, field});
        console.log('====================================');
        if(option){
            let IDList = option.map( item => item.value)
            this.setState({                
                [field]: option,
                [`${field}ID`]: IDList,
                page: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
                [`${field}ID`]: [],
                page: 0,
                // checkedItems :[]
            })

        }
    }
    validate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "equipement_date_acquisition",
            // "equipement_date_service",
            "equipement_name",
            "equipement_desc",
            "equipement_category",
            "equipement_quantity",
            "equipement_localisation",
            "equipement_brut_amount",
            "equipement_state",
            // "equipement_sn",
            "equipement_brand",
            "equipement_photo_front",
            "equipement_photo_back",
            // "equipement_photo_top",
            // "equipement_photo_bottom",
            "equipement_photo_left",
            "equipement_photo_right",
        ]
            
        if (this.props.type === "vehicule") {
            required = required.concat([
                "car_matricule",
                "car_km_start",
                "car_carburant",
                "car_assurance_start",
                "car_assurance_end",
                "car_controle_tech_start",
                "car_controle_tech_end",
                // "equipement_annual_rate",
                // "equipement_amt_length",
                // "equipement_report",
                // "equipement_exercice",
            ])
        }
        // if (this.props.type === "immo") { // opt to complete later
        //     required.concat([
        //         "equipement_annual_rate",
        //         "equipement_amt_length",
        //         // "equipement_report",
        //         // "equipement_exercice",
                
        //     ])
        // }

        console.log('====================================');
        console.log({required}, this.props.type);
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            let realType = this.props.type == "vehicule"  ? "vehicule" : (parseFloat(this.state.equipement_brut_amount) > 50000 ? "immo" : "materiel")

            data.equipement_type = realType
            data.equipement_date_acquisition = this.state.equipement_date_acquisition
            data.equipement_date_service = this.state.equipement_date_service
            data.equipement_name = this.state.equipement_name.trim()
            data.equipement_desc = this.state.equipement_desc
            data.equipement_sn = this.state.equipement_sn
            data.equipement_brand = this.state.equipement_brand.trim()
            data.equipement_category = this.state.equipement_category
            data.equipement_localisation = this.state.equipement_localisation
            data.equipement_quantity = parseInt(this.state.equipement_quantity)
            data.equipement_brut_amount = parseFloat(this.state.equipement_brut_amount)
            data.equipement_state = this.state.equipement_state
            data.equipement_remarks = this.state.equipement_remarks

            data.equipement_photo_front = this.state.equipement_photo_front
            data.equipement_photo_back = this.state.equipement_photo_back
            data.equipement_photo_top = this.state.equipement_photo_top ? this.state.equipement_photo_top : null
            data.equipement_photo_bottom = this.state.equipement_photo_bottom ? this.state.equipement_photo_bottom : null
            data.equipement_photo_left = this.state.equipement_photo_left
            data.equipement_photo_right = this.state.equipement_photo_right
            data.equipement_tags = isEmpty(this.state.equipement_tags) ? "" : this.state.equipement_tagsID.join(", ")

            data.no_loan = false
            data.permanent_loan = false
            data.short_loan = false
            
            data[this.state.loan_type] = true
            // GENERATE REF IN BACK ==> cat.code + equipement_intern_id + date.getFullYear() 
            
            if (realType === "vehicule") {
                data.car_matricule = this.state.car_matricule
                data.car_km_start = this.state.car_km_start
                data.car_carburant = this.state.car_carburant
                data.car_assurance_start = this.state.car_assurance_start
                data.car_assurance_end = this.state.car_assurance_end
                data.car_controle_tech_start = this.state.car_controle_tech_start
                data.car_controle_tech_end = this.state.car_controle_tech_end
                data.equipement_annual_rate = parseFloat(this.state.equipement_annual_rate)
                data.equipement_amt_length = parseFloat(this.state.equipement_amt_length)
                data.equipement_report = parseFloat(this.state.equipement_report) // à calculer
                data.equipement_exercice = parseFloat(this.state.equipement_exercice) // à calculer

            } else if ( realType === "immo" ) {
                data.equipement_annual_rate = parseFloat(this.state.equipement_annual_rate)
                data.equipement_amt_length = parseFloat(this.state.equipement_amt_length)
                data.equipement_report = parseFloat(this.state.equipement_report) // à calculer
                data.equipement_exercice = parseFloat(this.state.equipement_exercice) // à calculer
            }
            
            console.log('====================================');
            console.log("submit equipement", {data});
            console.log('====================================');
        
            await this.props.newEquipement(data)

            // // if NoErrors ...
            if(this.props.STATE.equipements.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.equipements.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "equipement_date_acquisition",
            // "equipement_date_service",
            "equipement_name",
            "equipement_desc",
            "equipement_category",
            // "equipement_intern_id",
            "equipement_localisation",
            "equipement_brut_amount",
            "equipement_state",
            // "equipement_sn",
            "equipement_brand",
            // "equipement_photo_front",
            // "equipement_photo_back",
            // "equipement_photo_top",
            // "equipement_photo_bottom",
            // "equipement_photo_left",
            // "equipement_photo_right",
        ]
            
        if (this.props.type === "vehicule") {
            required = required.concat([
                "car_matricule",
                "car_km_start",
                "car_carburant",
                "car_assurance_start",
                "car_assurance_end",
                "car_controle_tech_start",
                "car_controle_tech_end",
            ])
        }

        console.log('====================================');
        console.log({required}, this.props.type);
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmitUpdate = async () => {

        if( this.validateUpdate() ){
            let data = Object.assign({}, this.props.equipement)
            data.equipement_date_acquisition = this.state.equipement_date_acquisition
            data.equipement_date_service = this.state.equipement_date_service
            data.equipement_name = this.state.equipement_name
            data.equipement_desc = this.state.equipement_desc
            data.equipement_sn = this.state.equipement_sn
            data.equipement_brand = this.state.equipement_brand
            data.equipement_category = this.state.equipement_category
            data.equipement_localisation = this.state.equipement_localisation
            // data.equipement_intern_id = this.state.equipement_intern_id
            data.equipement_brut_amount = parseFloat(this.state.equipement_brut_amount)
            data.equipement_state = this.state.equipement_state
            data.equipement_remarks = this.state.equipement_remarks
            data.equipement_tags = isEmpty(this.state.equipement_tags) ? "" : this.state.equipement_tagsID.join(", ")

            // data.equipement_photo_front = this.state.equipement_photo_front
            // data.equipement_photo_back = this.state.equipement_photo_back
            // data.equipement_photo_top = this.state.equipement_photo_top
            // data.equipement_photo_bottom = this.state.equipement_photo_bottom
            // data.equipement_photo_left = this.state.equipement_photo_left
            // data.equipement_photo_right = this.state.equipement_photo_right

            data.no_loan = false
            data.permanent_loan = false
            data.short_loan = false
            
            data[this.state.loan_type] = true
            // GENERATE REF IN BACK ==> cat.code + equipement_intern_id + date.getFullYear() 
            
            if (this.props.type === "vehicule") {
                data.car_matricule = this.state.car_matricule
                data.car_km_start = parseFloat(this.state.car_km_start)
                data.car_carburant = this.state.car_carburant
                data.car_assurance_start = this.state.car_assurance_start
                data.car_assurance_end = this.state.car_assurance_end
                data.car_controle_tech_start = this.state.car_controle_tech_start
                data.car_controle_tech_end = this.state.car_controle_tech_end
                data.equipement_annual_rate = parseFloat(this.state.equipement_annual_rate)
                data.equipement_amt_length = parseFloat(this.state.equipement_amt_length)
                data.equipement_report = parseFloat(this.state.equipement_report) // à calculer
                data.equipement_exercice = parseFloat(this.state.equipement_exercice) // à calculer

            } else if ( this.props.type === "immo" ) {
                data.equipement_annual_rate = parseFloat(this.state.equipement_annual_rate)
                data.equipement_amt_length = parseFloat(this.state.equipement_amt_length)
                data.equipement_report = parseFloat(this.state.equipement_report) // à calculer
                data.equipement_exercice = parseFloat(this.state.equipement_exercice) // à calculer
            }
            
            console.log('====================================');
            console.log("submit equipement", {data});
            console.log('====================================');
        
            if(this.props.type === "vehicule"){
                await this.props.updateVehicule(data)
            } else {
                await this.props.updateEquipement(data)
            }

            // // if NoErrors ...
            if(this.props.STATE.equipements.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.equipements.error}`)
            } else { 
                this.props.notif("success", "l'équipement a été modifié")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { CATEGORIES, LOCALISATIONS, update, IMMO_TAGS } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log(this.props);
        console.log('====================================');
        return (
            <Dialog
                title={update ? "Modifier l'équipement" :`Nouvel équipement`}
                close={this.props.handleClose}
                submitAction={update ? this.handleSubmitUpdate : this.handleSubmit}
                appBar
                maxWidth="md"
                disabledSubmit={this.props.STATE.equipements.fetching}
            >
                <Grid container >
                    <Grid item xs={12}>
                        <Box p={1}>
                            <GroupRadio groupName="Type" value={this.props.type} >
                                <SingleRadio value="immo" label="Immobilisation" disabled={this.props.type !== "immo"} />
                                <SingleRadio value="materiel" label="Matériel" disabled={this.props.type !== "materiel"} />
                                <SingleRadio value="vehicule" label="Véhicule" disabled={this.props.type !== "vehicule"} />
                            </GroupRadio>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <DatePickerCmp  
                                id="equipement_date_acquisition" 
                                label="Date d'aquisition" 
                                name="equipement_date_acquisition" 
                                value={this.state.equipement_date_acquisition} 
                                handleChange={(date) => this.handleChangeDate("equipement_date_acquisition", date)} 
                                error={this.state.errors.equipement_date_acquisition}
                                required
                                noPadding
                                // disabled={this.props.update}
                            />      
                        </Box>
                    </Grid>   
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <DatePickerCmp  
                                id="equipement_date_service" 
                                label="Date de mise en Service" 
                                name="equipement_date_service" 
                                value={this.state.equipement_date_service} 
                                handleChange={(date) => this.handleChangeDate("equipement_date_service", date)} 
                                error={this.state.errors.equipement_date_service}
                                // required
                                noPadding
                            />      
                        </Box>
                    </Grid>               
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_name"
                            error={this.state.errors.equipement_name}
                            value={this.state.equipement_name}
                            name="equipement_name"
                            label="Intitulé"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            // required
                            id="equipement_sn"
                            error={this.state.errors.equipement_sn}
                            value={this.state.equipement_sn}
                            name="equipement_sn"
                            label="N° de Série"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_brand"
                            error={this.state.errors.equipement_brand}
                            value={this.state.equipement_brand}
                            name="equipement_brand"
                            label="Marque"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Creatable
                            label="Catégorie"
                            required
                            error={this.state.errors.equipement_category}
                            id="equipement_category"
                            options={Object.values(CATEGORIES.CHILD).filter( cat => cat.is_active !== false && !isEmpty(cat.category_equipement_code)).map( item => ({
                                label: item.category_name,
                                value: item.category_id
                            }))}
                            value={this.state.equipement_categoryDisplay}
                            onChange={(option) => this.handleChangeCat("equipement_category", option)}
                            disabled={this.props.update && !this.props.equipement.equipement_is_new}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Creatable
                            label="Localisation"
                            required
                            error={this.state.errors.equipement_localisation}
                            id="equipement_localisation"
                            options={Object.values(LOCALISATIONS.CHILD).map( item => ({
                                label: `${LOCALISATIONS.PARENT[item.loc_parent].loc_name} - ${item.loc_name}`,
                                value: item.loc_id
                            }))}
                            value={this.state.equipement_localisationDisplay}
                            onChange={(option) => this.handleChangeCat("equipement_localisation", option)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_quantity"
                            error={this.state.errors.equipement_quantity}
                            value={this.state.equipement_quantity}
                            name="equipement_quantity"
                            label="Quantité"
                            type="number"
                            disabled={this.props.update}
                        />
                        
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_intern_id"
                            error={this.state.errors.equipement_intern_id}
                            value={this.state.equipement_intern_id}
                            name="equipement_intern_id"
                            label="Référence" // code materiel
                            placeholder="003"
                            disabled={this.props.update && !this.props.equipement.equipement_is_new}
                        />
                        
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_brut_amount"
                            error={this.state.errors.equipement_brut_amount}
                            value={this.state.equipement_brut_amount}
                            name="equipement_brut_amount"
                            label="Valeur Brute"
                            type="number"
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            multiline
                            rows={5}
                            id="equipement_desc"
                            error={this.state.errors.equipement_desc}
                            value={this.state.equipement_desc}
                            name="equipement_desc"
                            label="Description"
                        />
                    </Grid>
                    <Grid container item xs={12} sm={6}>
                        <Grid item xs={12}>
                            <InputSelectNative
                                labelWidth={60}
                                onChange={ (e) => this.setState({ equipement_state: e.target.value })}
                                error={this.state.errors.equipement_state}
                                value={this.state.equipement_state}
                                label="Etat Général"
                                options={[
                                    <option>Neuf</option>,
                                    <option>Bon</option>,
                                    <option>Moyen</option>,
                                    <option>Mauvais</option>,
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputText
                                onChange={this.handleChange}
                                multiline
                                rows={2}
                                id="equipement_remarks"
                                error={this.state.errors.equipement_remarks}
                                value={this.state.equipement_remarks}
                                name="equipement_remarks"
                                label="Remarques"
                            />
                        </Grid>
                    </Grid>
                    {IMMO_TAGS &&
                        <Grid item xs={12}>
                            <InputSelectMultiV2
                                label="Mots Clés"
                                id="equipement_tags"
                                options={Object.values(IMMO_TAGS).map( item => ({
                                    label: item.immo_tag_name,
                                    value: item.immo_tag_id,
                                    disabled: Array.isArray(this.state.equipement_tags) && !!this.state.equipement_tags.find(element => element.value === item.immo_tag_id)
                                }))}
                                value={this.state.equipement_tags}
                                onChange={(option) => this.handleChangeMulti(option, "equipement_tags")}
                                isMulti
                                withCheckBox
                            />
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <Box p={1}>
                            <GroupRadio groupName="loan_type" value={this.state.loan_type} onChange={this.handleChange}>
                                <SingleRadio value="permanent_loan" label="Affectation Permanente" checked={this.state.loan_type === "permanent_loan"} />
                                <SingleRadio value="short_loan" label="Empruntable" checked={this.state.loan_type === "short_loan"} />
                                <SingleRadio value="no_loan" label="Non Affectable / Non Empruntable" checked={this.state.loan_type === "no_loan"} />
                            </GroupRadio>
                        </Box>
                    </Grid>
                    {this.state.equipement_brut_amount >= 50000 && this.props.type !== "materiel" &&
                        <Fragment>

                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Amortissement</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputText
                                    onChange={this.handleChange}
                                    // required
                                    id="equipement_annual_rate"
                                    error={this.state.errors.equipement_annual_rate}
                                    value={this.state.equipement_annual_rate}
                                    name="equipement_annual_rate"
                                    label="Taux Annuel"
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputText
                                    onChange={this.handleChange}
                                    // required
                                    id="equipement_amt_length"
                                    error={this.state.errors.equipement_amt_length}
                                    value={this.state.equipement_amt_length}
                                    name="equipement_amt_length"
                                    label="Durée (années)"
                                    type="number"
                                />
                            </Grid>
                            {/* {!isEmpty(this.state.equipement_amt_length) && this.state.equipement_date_service.getFullYear() !== 1 && (this.state.equipement_date_service.getFullYear() < new Date().getFullYear()) &&
                                <Grid item xs={12}>
                                    <Box p={1}>
                                        <SingleCheckbox 
                                            label="Rattrapage des amortissements antérieurs" checked={this.state.rattrapage} 
                                            onChange={(e) => this.setState({rattrapage: e.target.checked })}
                                        />
                                    </Box>
                                </Grid>
                            } */}
                            {this.state.rattrapage &&
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Box p={1}>
                                            <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Amortissement effectués</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            onChange={this.handleChange}
                                            required
                                            id="equipement_report"
                                            error={this.state.errors.equipement_report}
                                            value={this.state.equipement_report}
                                            name="equipement_report"
                                            label="Report"
                                            type="number"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            onChange={this.handleChange}
                                            required
                                            id="equipement_exercice"
                                            error={this.state.errors.equipement_exercice}
                                            value={this.state.equipement_exercice}
                                            name="equipement_exercice"
                                            label="Exercice"
                                            type="number"
                                        />
                                    </Grid>
                                </Fragment>
                            }
                        </Fragment>
                    }
                    {this.props.type === "vehicule" &&
                        <Fragment>
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Informations Complémentaires</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputText
                                    onChange={this.handleChange}
                                    required
                                    id="car_matricule"
                                    error={this.state.errors.car_matricule}
                                    value={this.state.car_matricule}
                                    name="car_matricule"
                                    label="Immatriculation"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputText
                                    onChange={this.handleChange}
                                    required
                                    id="car_km_start"
                                    error={this.state.errors.car_km_start}
                                    value={this.state.car_km_start}
                                    name="car_km_start"
                                    label="Kilométrage Départ (Km)"
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputSelectNative
                                    labelWidth={60}
                                    value={this.state.car_carburant}
                                    error={this.state.errors.car_carburant}
                                    onChange={ (e) => this.setState({ car_carburant: e.target.value })}
                                    label="Type de Carburant"
                                    options={[
                                        <option>Essence</option>,
                                        <option>Gasoil</option>,
                                        <option>Électrique</option>,
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Assurance</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <DatePickerCmp  
                                        id="car_assurance_start" 
                                        label="Date de début" 
                                        name="car_assurance_start" 
                                        value={this.state.car_assurance_start} 
                                        handleChange={(date) => this.handleChangeDate("car_assurance_start", date)} 
                                        error={this.state.errors.car_assurance_start}
                                        required
                                        noPadding
                                    />      
                                </Box>
                            </Grid>   
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <DatePickerCmp  
                                        id="car_assurance_end" 
                                        label="Date d'expiration" 
                                        name="car_assurance_end" 
                                        value={this.state.car_assurance_end} 
                                        handleChange={(date) => this.handleChangeDate("car_assurance_end", date)} 
                                        error={this.state.errors.car_assurance_end}
                                        required
                                        noPadding
                                    />      
                                </Box>
                            </Grid>   
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Controle Technique</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <DatePickerCmp  
                                        id="car_controle_tech_start" 
                                        label="Date dernier contrôle" 
                                        name="car_controle_tech_start" 
                                        value={this.state.car_controle_tech_start} 
                                        handleChange={(date) => this.handleChangeDate("car_controle_tech_start", date)} 
                                        error={this.state.errors.car_controle_tech_start}
                                        required
                                        noPadding
                                    />      
                                </Box>
                            </Grid>   
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <DatePickerCmp  
                                        id="car_controle_tech_end" 
                                        label="Date prochain contrôle" 
                                        name="car_controle_tech_end" 
                                        value={this.state.car_controle_tech_end} 
                                        handleChange={(date) => this.handleChangeDate("car_controle_tech_end", date)} 
                                        error={this.state.errors.car_controle_tech_end}
                                        required
                                        noPadding
                                    />      
                                </Box>
                            </Grid>   
                            
                        </Fragment>
                    }
                    {!this.props.update &&
                        <>
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Photos</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="av" label="Photo Face Avant" setPhoto={(pic) => this.setPhotos("equipement_photo_front", pic)} photos={this.state.equipement_photo_front === null ? [] : this.state.equipement_photo_front } error={this.state.errors.equipement_photo_front} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="ar" label="Photo Face Arrière" setPhoto={(pic) => this.setPhotos("equipement_photo_back", pic)} photos={this.state.equipement_photo_back === null ? [] : this.state.equipement_photo_back } error={this.state.errors.equipement_photo_back} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="left" label="Photo Face Gauche" setPhoto={(pic) => this.setPhotos("equipement_photo_left", pic)} photos={this.state.equipement_photo_left === null ? [] : this.state.equipement_photo_left } error={this.state.errors.equipement_photo_left} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="right" label="Photo Face Droite" setPhoto={(pic) => this.setPhotos("equipement_photo_right", pic)} photos={this.state.equipement_photo_right === null ? [] : this.state.equipement_photo_right } error={this.state.errors.equipement_photo_right} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="top" label="Photo Haut" setPhoto={(pic) => this.setPhotos("equipement_photo_top", pic)} photos={this.state.equipement_photo_top === null ? [] : this.state.equipement_photo_top } error={this.state.errors.equipement_photo_top} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box p={1}>
                                    <PhotoUpload id="bottom" label="Photo Bas" setPhoto={(pic) => this.setPhotos("equipement_photo_bottom", pic)} photos={this.state.equipement_photo_bottom === null ? [] : this.state.equipement_photo_bottom } error={this.state.errors.equipement_photo_bottom} />
                                </Box>
                            </Grid>
                        </>
                    }
                </Grid>      
            </Dialog>
        );
    }
}

export default Equipements;